@if (question) {
  <rt-box [class.invalid]="invalid" variant="default vertical no-padding" margin-bottom>
    @if (!question.questionHint) {
      <div class="box-header" padding>
        <div class="first-row">
          <rt-heading class="heading">
            {{ question.questionTitle }}
            @if (question.questionRequired) {
              <span class="required" margin-left-small-xx> * </span>
            }
          </rt-heading>
          @if (invalid) {
            <div class="error-message">
              {{
                errorMessage ??
                  ((!question.summary
                    ? 'app.common.form.required_error'
                    : 'app.candidate.required_summary'
                  ) | translate)
              }}
            </div>
          }
        </div>
        @if (question.time) {
          <rt-date [time]="question.time" variant="small"> </rt-date>
        }
      </div>
    }

    @if (question.questionHint) {
      <div class="box-header hint" padding-lr padding-tb-small>
        <div class="first-row">
          <rt-heading class="heading">
            {{ question.questionTitle }}
            @if (question.questionRequired) {
              <span class="required" margin-left-small-xx> * </span>
            }
          </rt-heading>
          @if (invalid) {
            <div class="error-message">
              {{
                errorMessage ??
                  ((!question.summary
                    ? 'app.common.form.required_error'
                    : 'app.candidate.required_summary'
                  ) | translate)
              }}
            </div>
          }
        </div>
        <rt-heading class="subheading small">
          {{ question.questionHint }}
        </rt-heading>
      </div>
    }

    <rt-divider></rt-divider>
    <div class="box-body" [attr.padding]="padding ? '' : null">
      <ng-content></ng-content>
    </div>
  </rt-box>
}
